import { AxiosError } from 'axios';
import { IOptionType } from '../../api/candidate/exam/model';
import { GET_NON_NATIONAL_EXAM_SCHOOLING_DETAIL } from '../../constants/apiUrls';
import { SchoolFormData, SiblingFormData } from '../../models';
import axiosClient from '../axiosClient';
import { GenericErrorResponse } from '../typings';
import { useCustomQuery } from '../utils/useCustomQuery';

// =============================================================================
// Request & Response Model
// =============================================================================

interface CaeCertificateDetailsModelProps {
  ceqTypeUuid: string;
  centreRefNo: string;
  verificationNo: string;
  country: IOptionType;
  dateTaken: string;
  overallScore: string;
  readingScore: string;
  writingScore: string;
  listeningScore: string;
  speakingScore: string;
}

export interface GetNonNationalExamSchoolingDetailsResponse {
  caeCertificateDetailsModel: CaeCertificateDetailsModelProps;
  schoolInfo: boolean;
  examSchoolInfoModels: SchoolFormData[];
  siblingInfo: boolean;
  examSiblingInfoModels: SiblingFormData[];
  selectedAdmissionLevel: string;
  lockedByUser?: string;
  motherTongueLanguageToBeTaken: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: GetNonNationalExamSchoolingDetailsResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetNonNationalExamSchoolingDetails = ({ uuid, onSuccess, onError }: Input) => {
  const getNonNationalExamSchoolingDetails = async () => {
    const res = await axiosClient.get<GetNonNationalExamSchoolingDetailsResponse>(
      GET_NON_NATIONAL_EXAM_SCHOOLING_DETAIL(uuid)
    );

    return res.data;
  };

  return useCustomQuery(
    [GET_NON_NATIONAL_EXAM_SCHOOLING_DETAIL(uuid)],
    getNonNationalExamSchoolingDetails,
    {
      onSuccess,
      onError,
    }
  );
};
